import { ApolloClient } from "apollo-client";
import { ApolloLink, Operation } from "apollo-link";
import { HttpLink } from "apollo-link-http";

import environment from "../../environment";
import GetProduct from "../../hoc/repository/withProduct/graphql/GetProduct";
import i18n from "../../i18n";
import { Mapping } from "../../types/primitives";
import { IProduct } from "../../types/product";

import apolloCache from "./apolloCache";
import { errorLink } from "./links/errorLink";
import { languageLink } from "./links/languageLink";

const httpLink: HttpLink = new HttpLink({
  credentials: "include",
  uri: environment.REACT_APP_GRAPHQL_ENDPOINT,
});

/*
TODO

add cache header
Cache-Control: public, max-age=600

dont send cookies

*/
const customFetch = async (
  uri: string,
  options: RequestInit
): Promise<Response> => {
  return fetch(uri + "&lang=" + i18n.language, options);
};

const cachingHttpLink: HttpLink = new HttpLink({
  fetch: customFetch,
  uri: environment.REACT_APP_GRAPHQL_ENDPOINT,
  useGETForQueries: true,
});

// tslint:disable-next-line: typedef
const routingLink: ApolloLink = new ApolloLink((operation: Operation) => {
  if (operation.operationName && operation.operationName.startsWith("Get")) {
    return cachingHttpLink.request(operation);
  } else {
    return httpLink.request(operation);
  }
});

type IProdOrUnde = IProduct | undefined;

const client = new ApolloClient({
  cache: apolloCache,
  link: ApolloLink.from([errorLink, languageLink, routingLink].filter(Boolean)),
  resolvers: {
    Query: {
      products: async (
        _: Mapping,
        args: { ids: string[] }
      ): Promise<
        { __typename: "Products"; products: IProduct[] } | IProduct[] | null
      > => {
        const { ids } = args;
        if (!ids || ids.length <= 0) {
          return null;
        }

        const promises = ids.map(
          async (id: string): Promise<IProdOrUnde> =>
            client
              .watchQuery({
                query: GetProduct,
                variables: { id },
                returnPartialData: true,
                fetchPolicy: "cache-only",
              })
              .result()
              .then(
                ({ data }: { data: { product: IProdOrUnde } }): IProdOrUnde =>
                  data?.product
              )
        );

        const products = (await Promise.all<IProdOrUnde>(promises)).filter(
          (product: IProdOrUnde): boolean => !!product
        ) as IProduct[];

        return products;
      },
    },
  },
});

export default client;
